import { TableColumnsInterface } from "constants/interfaces"

import { isMicroserviceTenant } from "config/featureFlags"

// Call at render: the tenant mode resolves after login.
export const isColumnSortable = (column: TableColumnsInterface): boolean => {
  if (isMicroserviceTenant()) {
    return column.sorting
  }
  return column.mntSorting ?? column.sorting
}
